import * as React from 'react'

function ArchTargetMultiIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={36}
      height={36}
      viewBox="0 0 36 36"
    >
      <defs>
        <filter
          id="prefix__b"
          width="103.5%"
          height="103.5%"
          x="-1.7%"
          y="-1.7%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur
            in="SourceAlpha"
            result="shadowBlurInner1"
            stdDeviation={0.5}
          />
          <feOffset in="shadowBlurInner1" result="shadowOffsetInner1" />
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            k2={-1}
            k3={1}
            operator="arithmetic"
            result="shadowInnerInner1"
          />
          <feColorMatrix
            in="shadowInnerInner1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.129971591 0"
          />
        </filter>
        <path
          id="prefix__a"
          d="M18.113 17.064h.022l.012.001.053.005.027.004.017.002.02.004.01.002.051.011.016.005 8.662 2.32 2.24-1.292a.999.999 0 011.097 1.667l-.097.065-.509.292.165.044 2.241-1.292a1 1 0 011.098 1.668l-.098.064-.509.292.2.054a.999.999 0 01-.404 1.955l-.114-.023-.199-.054.294.508a1 1 0 01-.268 1.302l-.098.064a1 1 0 01-1.302-.268l-.064-.098-1.294-2.24-.165-.044.294.508a1 1 0 01-.269 1.302l-.098.064a.989.989 0 01-.643.123 1 1 0 01-.668 1.611l-.117.007h-.587l.122.121h2.587a1 1 0 01.116 1.994l-.116.006h-.587l.145.145a1 1 0 01-1.327 1.492l-.087-.078-.145-.145v.586a1 1 0 01-.883.994l-.116.006a1 1 0 01-.994-.883l-.006-.117v-2.586l-.123-.122.001.587a1 1 0 01-.883.993l-.117.007a.996.996 0 01-.618-.214 1.002 1.002 0 01-1.385 1.061l-.104-.053-.508-.293.044.165 2.24 1.294a1 1 0 01-.895 1.785l-.105-.053-.508-.294.054.199a1 1 0 01-1.895.628l-.037-.11-.054-.2-.292.51a1.001 1.001 0 01-1.261.418l-.105-.053a.999.999 0 01-.418-1.261l.052-.105 1.292-2.24-.044-.166-.292.508a1 1 0 01-1.262.419l-.104-.053a1 1 0 01-.419-1.261l.053-.105 1.292-2.239-2.32-8.662-.006-.02-.011-.054-.002-.008-.003-.02-.002-.012-.004-.028-.004-.042v-.016l-.002-.017V18.022l.001-.018.001-.014.004-.046.006-.038.003-.019c.005-.028.01-.048.015-.068l.004-.014c.01-.037.02-.067.03-.096l.006-.015c.012-.03.022-.05.032-.072l.026-.05.028-.046.04-.059.027-.033.023-.028.01-.01.031-.035.006-.005.07-.064.039-.03.006-.005a.826.826 0 01.061-.042l.038-.022.03-.017.032-.015.029-.014.011-.004.05-.02.041-.014.01-.003.011-.003.008-.003.008-.001a.91.91 0 01.087-.02h.003l.008-.002.02-.003.033-.004.043-.004.027-.002h.072zm9.08-8.256a12.947 12.947 0 013.685 7.407 3.001 3.001 0 00-2.038-.085 10.933 10.933 0 00-3.062-5.908c-4.296-4.296-11.26-4.296-15.556 0-4.296 4.296-4.296 11.26 0 15.556a10.946 10.946 0 005.922 3.065 2.99 2.99 0 00.099 2.038 12.93 12.93 0 01-7.435-3.689c-5.077-5.076-5.077-13.308 0-18.384 5.076-5.077 13.308-5.077 18.384 0zm-7.179 12.601l1.355 5.057 2.24 1.293c.042.025.082.052.12.081l-.006-.026-.007-.117V25.11l-3.702-3.7zm4.35-9.773a8.966 8.966 0 012.595 5.5l-.239.136-1.826-.488A7.002 7.002 0 0013.05 13.05a7.002 7.002 0 003.758 11.848l.483 1.803-.147.258a8.96 8.96 0 01-5.508-2.595 9 9 0 010-12.728 9 9 0 0112.728 0zm-2.936 8.36l3.701 3.7 2.587.001c.05 0 .098.004.145.01l-.018-.02-.065-.097-1.293-2.24-5.057-1.355zm.108-5.532c.505.506.88 1.093 1.124 1.72l-3.427-.92a3.001 3.001 0 00-3.912 4.089l.89 3.317a5.002 5.002 0 01-1.747-8.206 5.002 5.002 0 017.072 0z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <use fill="#E8E9EB" xlinkHref="#prefix__a" />
        <use fill="#000" filter="url(#prefix__b)" xlinkHref="#prefix__a" />
      </g>
    </svg>
  )
}

export default ArchTargetMultiIcon
